import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import Card from "../models/common/Card";


function CardsFormatTwo(props) {

    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [cards] = useState<Record<number, Card[]>>(props.cards);
    const [eyeBrownHeader] = useState(props.eyeBrownHeader);
    const [cardHeight] = useState(props.cardHeight);

    const cardHeightStyle = {
        height: cardHeight ? cardHeight : 584,
    }


    function createRows() {
        let htmlList: JSX.Element[] = [];
        for (const key in cards) {
            console.log(cards[key]);
            htmlList[key] = fillRow(cards[key]);
        }
        return htmlList;
    }

    function fillRow(cardsList: Card[]) {
        console.log(cardHeightStyle);
        return <div className="rowCard justify-content-center ">
            {cardsList.map(c =>
                <div className="cardSection2" style={cardHeightStyle}>
                    <img src={c.image} className="cardImage" alt='...' />
                    {/* <div className="cardTitle2 mt-4">{c.title}</div> */}
                    {addTittle(c)}
                    <div className="cardText2 mt-2">
                        <div className="cardTextLetter">{c.subTitle == "" ? c.htmlCode : c.subTitle}
                        </div>
                    </div>
                </div>
            )}

        </div>
    }

    
 

    function addTittle(card: Card) {
        return card.title === "" ? "" : <div className="cardTitle2 mt-4">{card.title}</div>;
    }

    function addMoreSpace() {
        return subTitle === "" ? "headerOne" : "headerOne headerOneHeight";
    }


    return (

        <div id="cardsFormat2">
            <div className="row headerGeneral">
                <div className="headerGeneralContent headerLetter mb-5">
                    <div className={addMoreSpace()}>
                        <div className="benefEyebrowHeader">
                            {eyeBrownHeader}
                        </div>
                        {title}
                        <br></br>
                        {subTitle}
                    </div>
                </div>
            </div>

            <div >
                {createRows()}
            </div>
        </div>

    )


}

export default withRouter(CardsFormatTwo);



